import { render, staticRenderFns } from "./SelectOrganizationDialog.vue?vue&type=template&id=316c9365&"
import script from "./SelectOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./SelectOrganizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports